let openDialogHandler = null;

export const registerDialogHandler = (handler) => {
  openDialogHandler = handler;
};

export const initiateConfirmationDialog = (info, yesFun) => {
  if (openDialogHandler) {
    openDialogHandler(info, yesFun);
  }
};
